import { setSessionStorage } from "@/helpers/handleSessionStorage";
import isSessionStorageEnabled from "@/helpers/isSessionStorageEnabled";
import { dispatchCustomEvent } from "@/helpers/triggerAnalyticsEvent";
import clsx from "clsx";
import { Dispatch, SetStateAction } from "react";

const FilterButton = ({
  src,
  text,
  selected,
  setSelected,
}: {
  src: string;
  text: string;
  selected: string;
  setSelected: Dispatch<SetStateAction<string>>;
}) => {
  const handleClick = () => {
    if (selected === text) {
      setSelected("");
      isSessionStorageEnabled() && setSessionStorage("syfIncFilter", "");
      dispatchCustomEvent({
        dataObject: "body-filter",
        dataType: "button",
        dataReason: "reset-filters",
      });
    } else {
      setSelected(text);
      isSessionStorageEnabled() && setSessionStorage("syfIncFilter", text);

      const textWithoutSpaces = text.replace(/\s+/g, "");

      dispatchCustomEvent({
        dataObject: "body-filter",
        dataType: "button",
        dataReason: textWithoutSpaces,
      });
    }
  };
  return (
    <button
      id={text}
      onClick={handleClick}
      className={clsx(
        selected === text ? "bg-charcoal text-white" : "bg-white text-charcoal",
        "group syfclickevent flex items-center justify-center gap-2 py-[8px] px-[16px] rounded-[8px] shadow-filter  hover:bg-syfYellow hover:text-charcoal transition duration-150"
      )}
      tabIndex={0}
      data-object="body-filter"
      data-type="button"
      data-reason={text.trim()}
    >
      <img src={src}  className={clsx(
        selected === text ? "w-[20px] h-[20px]  invert group-hover:invert-0 contrast-100":
        "w-[20px] h-[20px] filter contrast-50"
      )} />

      <span className="text-[16px] leading-[24px]">{text}</span>
    </button>
  );
};

export default FilterButton;
